// Constantes de règles partagées : utilisées par le serveur et affichées telles quelles dans la notice.

export const TEAM_SIZE = 6;

/** Boîte du PC : des pages de cases, en nombre limité. */
export const BOX_PAGES = 8;
export const BOX_PAGE_SIZE = 30;
export const BOX_CAPACITY = BOX_PAGES * BOX_PAGE_SIZE;

/** Rangements possibles de la boîte (le tri remplit les cases dans cet ordre, depuis la première). */
export const BOX_SORTS = { caught: 'Capture', level: 'Niveau', potential: 'Potentiel', rarity: 'Rareté' } as const;
export type BoxSort = keyof typeof BOX_SORTS;
export const isBoxSort = (value: unknown): value is BoxSort => typeof value === 'string' && Object.hasOwn(BOX_SORTS, value);
export const STARTER_LEVEL = 5;

/** Revanche contre un dresseur déjà battu : chaque victoire précédente ajoute ces niveaux à toute son équipe. */
export const REMATCH_LEVEL_STEP = 3;
/** Délai avant une revanche, en jours de jeu (voir la durée d'une journée dans la configuration). */
export const REMATCH_COOLDOWN_DAYS = 2;

/**
 * Temps qu'il reste avant de pouvoir redéfier un dresseur battu à `defeatedAt`, en heures de jeu (0 : c'est possible).
 * `cycleMinutes` : durée d'une journée de jeu, en minutes réelles.
 */
export function rematchWaitHours(defeatedAt: number, now: number, cycleMinutes: number): number {
  const hourMs = (cycleMinutes * 60_000) / 24;
  return Math.max(0, Math.ceil((defeatedAt + REMATCH_COOLDOWN_DAYS * 24 * hourMs - now) / hourMs));
}

/** Probabilité qu'un monstre sauvage soit chromatique. */
export const SHINY_CHANCE = 1 / 128;
/** Multiplicateurs de chance de chromatique proposés pour une zone (1 : normal). */
export const ZONE_SHINY_BOOSTS = [1, 2, 3, 5, 10, 20] as const;
export const MAX_ZONE_SHINY_BOOST = 20;
/** Chance qu'un monstre sauvage de la zone soit chromatique. */
export const shinyChance = (boost = 1): number => Math.min(1, SHINY_CHANCE * boost);

/** Part des pièces perdue quand toute l'équipe est K.O. (combat sauvage ou contre un dresseur PNJ). */
export const DEFEAT_COIN_PENALTY = 0.1;

/** Pièces perdues après une défaite, arrondies à l'unité inférieure. */
export const defeatPenalty = (coins: number): number => Math.floor(coins * DEFEAT_COIN_PENALTY);


export const DUEL_WIN_COINS = 0;
/** Délai de réflexion par tour de duel : passé ce délai, un coup est joué au hasard. */
export const DUEL_TURN_TIMEOUT_MS = 30_000;
/** Durée de validité d'un défi. */
export const DUEL_INVITE_TTL_MS = 30_000;
/** Une proposition de coop reste valable ce temps-là. */
export const COOP_INVITE_TTL_MS = 30_000;
